/**
 * DOCUMENT-DELETE-MODAL
 * Delete a generated document
 */
import Modal from "@/components/modal"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import EnterCodeWidget from "@/widgets/enter-code.widget"
import documentStore from "../../model/document.store"
import { Document } from "../../model/document.types"

interface Props {
  document: Document
  onClose: () => void
  onDelete: () => void
}

function formatDocumentDate(date: Date | string) {
  return new Date(date).toLocaleDateString("fr-FR", {
    month: "long",
    year: "numeric"
  })
}

export default function DocumentDeleteModal(props: Props) {
  const dispatch = useAppDispatch()
  const status = useAppSelector(documentStore.selectors.status)

  async function handleDelete() {
    await dispatch(documentStore.thunks.removeEntity(props.document.id)).unwrap()
    props.onDelete()
  }

  return (
    <Modal title="Supprimer le document" onClose={() => props.onClose()}>
      <p>
        <b>{`Voulez-vous supprimer le document de ${formatDocumentDate(props.document.date)} ?`}</b>
      </p>
      <EnterCodeWidget onCancel={() => props.onClose()} onNext={handleDelete} status={status} />
    </Modal>
  )
}
